export const STATUS_SENDING = 'sending';
export const STATUS_SENT = 'sent';
export const STATUS_RECEIVED = 'received';
export const STATUS_DELIVERED = 'delivered';
export const STATUS_UNDELIVERED = 'undelivered';
export const STATUS_READ = 'read';
export const STATUS_FAIL = 'fail';
export const STATUS_DELETED = 'deleted';
export const STATUS_HIDDEN = 'hidden';
export const STATUS_OPENED = 'opened';
export const STATE_STATUS_ACCEPT = 'accepted';
export const STATE_STATUS_DECLINE = 'declined';
export const STATE_STATUS_NULL = null;
export const STATE_GROUP_INVITED = 'groupInvited';
export const STATE_GROUP_CONFIRMED = 'groupConfirmed';

const ALL_STATUSES = {
  STATUS_SENDING,
  STATUS_SENT,
  STATUS_RECEIVED,
  STATUS_DELIVERED,
  STATUS_UNDELIVERED,
  STATUS_READ,
  STATUS_FAIL,
  STATUS_DELETED,
  STATUS_HIDDEN,
  STATUS_OPENED,
  STATE_STATUS_ACCEPT,
  STATE_STATUS_DECLINE,
  STATE_STATUS_NULL,
  STATE_GROUP_INVITED,
  STATE_GROUP_CONFIRMED,
} as const;

export type MessageStatusType = (typeof ALL_STATUSES)[keyof typeof ALL_STATUSES];
